<p>destructor works!</p>
